import { mergeTailwindClasses } from '@xefi/x-react/utils';
import PhoneInput, { type CountryData } from 'react-phone-input-2';
import fr from 'react-phone-input-2/lang/fr.json';

import type { InputFieldProps } from '@/models/inputFields';
import 'react-phone-input-2/lib/style.css';

type PhoneFieldProps = InputFieldProps<string>;

export const PhoneField = ({
   value,
   onChange,
   error,
   disabled = false,
}: PhoneFieldProps) => {
   return (
      <PhoneInput
         localization={fr}
         country='fr'
         countryCodeEditable={false}
         value={value}
         containerClass={mergeTailwindClasses({
            'border border-primary1 rounded-md': error,
         })}
         disabled={disabled}
         onChange={(value, data: CountryData) => {
            if (data.dialCode) {
               onChange?.(value);
            }
         }}
      />
   );
};
